module.exports = __webpack_public_path__ + "img/67.665783e7.jpg";